<!-- app/javascript/dashboard/routes/dashboard/products/pages/CatalogIndex.vue -->
<template>
  <div class="full-page bg-n-background text-n-slate-12">
    <div class="flex flex-col items-start w-full pt-4 mb-4">
      <div class="flex items-center justify-between w-full gap-4">
        <h1 class="text-2xl font-semibold font-interDisplay tracking-[0.3px] text-slate-900 dark:text-slate-25">
          <!-- DESABILITADO: Menu sempre aberto -->
          <!-- <woot-sidemenu-icon v-if="showSidemenuIcon" /> -->
          Cadastros
        </h1>
        <div class="flex gap-3">
          <!-- importar xls/csv -->
          <Button 
            variant="outline"
            color="blue"
            size="md"
            icon="i-lucide-file-spreadsheet"
            @click="openSheetModal"
          >
            <span class="min-w-0 truncate">Importar planilha</span>
          </Button>
          
          <!-- criar manualmente -->
          <Button 
            variant="solid" 
            color="blue" 
            size="md"
            icon="i-lucide-circle-plus"
            @click="openCatalogModal"
          >
            <span class="min-w-0 truncate">Adicionar cadastro</span>
          </Button>
        </div>
      </div>

      <div class="flex flex-col w-full gap-3 text-slate-600 dark:text-slate-300">
        <p class="mb-0 text-base font-normal line-clamp-5 sm:line-clamp-none max-w-3xl tracking-[-0.1px]">Produtos e serviços podem ser registrados nos cadastros para várias funcionalidades na aplicação, como material de conhecimento para IA e mensagens customizadas.</p>
      </div>
    </div>

    <!-- Combined Filter/Bulk Actions Bar - Toggles between filter mode and delete mode -->
    <div 
      class="sticky top-0 z-50 w-full bg-n-solid-2 dark:bg-slate-800 border border-n-weak rounded-lg py-3 px-4 flex items-center justify-between transition-all duration-200 ease-in-out shadow-sm"
    >
      <!-- Filter Mode - Shows when no products are selected -->
      <template v-if="selectedProductIds.length === 0">
        <!-- Search bar - takes remaining space -->
        <div class="flex-1 mr-4">
          <div class="inline-flex items-center w-full rounded-lg min-w-0 gap-2 px-3 py-1.5 bg-n-background outline-1 outline outline-n-container hover:outline-n-brand focus-within:outline-n-brand transition-all search-container h-8">
            <div class="flex flex-shrink-0">
              <fluent-icon
                icon="search"
                class="search--icon text-n-slate-11 transition-colors"
                size="16"
              />
            </div>
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Pesquisar cadastros"
              class="!flex-1 !bg-transparent !m-0 !p-0 !border-none !outline-none text-sm text-n-slate-12 placeholder:text-n-slate-9 !min-w-0"
            />
          </div>
        </div>
        
        <!-- Filter section -->
        <div class="flex items-center gap-4 flex-shrink-0 min-w-0">
          <div class="flex items-center gap-2 min-w-0">
            <span class="text-sm font-medium text-n-slate-12 flex-shrink-0">
              Filtros
            </span>
            <div class="relative flex items-center justify-end filter-actions min-w-0">
            <div class="rounded-lg button-group outline-1 outline outline-n-container min-w-0">
              <Button
:label="getFilterButtonLabel()"
                size="sm"
                color="slate"
                class="ltr:rounded-r-none rtl:rounded-l-none !outline-0 bg-n-background dark:bg-n-background min-w-0 flex-shrink"
                @click="openFilterDropdown"
              />
              <Button
                icon="i-lucide-chevron-down"
                size="sm"
                color="slate"
                class="ltr:rounded-l-none rtl:rounded-r-none !outline-0 bg-n-background dark:bg-n-background"
                trailing-icon
                @click="openFilterDropdown"
              />
            </div>
            <div
              v-if="showFilterDropdown"
              v-on-clickaway="closeFilterDropdown"
              class="dropdown-pane dropdown-pane--open left-auto top-full mt-0.5 ltr:right-0 rtl:left-0 max-w-[12.5rem] min-w-[9.75rem]"
            >
              <WootDropdownMenu class="mb-0">
                <WootDropdownItem>
                  <Button
                    label="Todos"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-layers"
                    class="w-full"
                    @click="() => selectFilterType('todos')"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="Ativos"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-check-circle"
                    class="w-full"
                    @click="() => selectFilterType('ativos')"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="Desativados"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-x-circle"
                    class="w-full"
                    @click="() => selectFilterType('desativados')"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="Digital"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-smartphone"
                    class="w-full"
                    @click="() => selectFilterType('digital')"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="Físico"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-package"
                    class="w-full"
                    @click="() => selectFilterType('physical')"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="Consulta"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-stethoscope"
                    class="w-full"
                    @click="() => selectFilterType('consulta')"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="Tratamento"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-heart-pulse"
                    class="w-full"
                    @click="() => selectFilterType('tratamento')"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="Delivery"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-truck"
                    class="w-full"
                    @click="() => selectFilterType('delivery')"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="Assinatura"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-refresh-cw"
                    class="w-full"
                    @click="() => selectFilterType('assinatura')"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="Aluguel"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-home"
                    class="w-full"
                    @click="() => selectFilterType('aluguel')"
                  />
                </WootDropdownItem>
              </WootDropdownMenu>
            </div>
          </div>
          </div>

          <!-- Inbox Filter section -->
          <div class="flex items-center gap-2 min-w-0">
            <span class="text-sm font-medium text-n-slate-12 flex-shrink-0">
              Inbox
            </span>
            <div class="relative flex items-center justify-end filter-actions min-w-0">
            <div class="rounded-lg button-group outline-1 outline outline-n-container min-w-0">
              <Button
                :label="getInboxFilterButtonLabel()"
                size="sm"
                color="slate"
                class="ltr:rounded-r-none rtl:rounded-l-none !outline-0 bg-n-background dark:bg-n-background min-w-0 flex-shrink"
                @click="openInboxFilterDropdown"
              />
              <Button
                icon="i-lucide-chevron-down"
                size="sm"
                color="slate"
                class="ltr:rounded-l-none rtl:rounded-r-none !outline-0 bg-n-background dark:bg-n-background"
                trailing-icon
                @click="openInboxFilterDropdown"
              />
            </div>
            <div
              v-if="showInboxFilterDropdown"
              v-on-clickaway="closeInboxFilterDropdown"
              class="dropdown-pane dropdown-pane--open left-auto top-full mt-0.5 ltr:right-0 rtl:left-0 max-w-[12.5rem] min-w-[9.75rem]"
            >
              <WootDropdownMenu class="mb-0">
                <WootDropdownItem>
                  <Button
                    label="Sem filtro"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-filter-x"
                    class="w-full"
                    @click="() => selectInboxFilter('no-filter')"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="Todos"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-globe"
                    class="w-full"
                    @click="() => selectInboxFilter(null)"
                  />
                </WootDropdownItem>
                <WootDropdownItem v-for="inbox in inboxes" :key="inbox.id">
                  <Button
                    :label="getInboxDisplayNameForDropdown(inbox)"
                    ghost
                    slate
                    sm
                    start
                    icon="i-lucide-message-circle"
                    class="w-full"
                    @click="() => selectInboxFilter(inbox.id)"
                  />
                </WootDropdownItem>
              </WootDropdownMenu>
            </div>
          </div>
          </div>

          <!-- Per Page section -->
          <div class="flex items-center gap-2 min-w-0">
            <span class="text-sm font-medium text-n-slate-12 flex-shrink-0">
              Por Página
            </span>
            <div class="relative flex items-center justify-end filter-actions min-w-0">
            <div class="rounded-lg button-group outline-1 outline outline-n-container min-w-0">
              <Button
                :label="pagination.pageSize.toString()"
                size="sm"
                color="slate"
                class="ltr:rounded-r-none rtl:rounded-l-none !outline-0 bg-n-background dark:bg-n-background min-w-0 flex-shrink"
                @click="openPageSizeDropdown"
              />
              <Button
                icon="i-lucide-chevron-down"
                size="sm"
                color="slate"
                class="ltr:rounded-l-none rtl:rounded-r-none !outline-0 bg-n-background dark:bg-n-background"
                trailing-icon
                @click="openPageSizeDropdown"
              />
            </div>
            <div
              v-if="showPageSizeDropdown"
              v-on-clickaway="closePageSizeDropdown"
              class="dropdown-pane dropdown-pane--open left-auto top-full mt-0.5 ltr:right-0 rtl:left-0 max-w-[12.5rem] min-w-[9.75rem]"
            >
              <WootDropdownMenu class="mb-0">
                <WootDropdownItem>
                  <Button
                    label="10"
                    ghost
                    slate
                    sm
                    start
                    class="w-full"
                    @click="() => selectPageSize(10)"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="50"
                    ghost
                    slate
                    sm
                    start
                    class="w-full"
                    @click="() => selectPageSize(50)"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="100"
                    ghost
                    slate
                    sm
                    start
                    class="w-full"
                    @click="() => selectPageSize(100)"
                  />
                </WootDropdownItem>
                <WootDropdownItem>
                  <Button
                    label="300"
                    ghost
                    slate
                    sm
                    start
                    class="w-full"
                    @click="() => selectPageSize(300)"
                  />
                </WootDropdownItem>
              </WootDropdownMenu>
            </div>
          </div>
          </div>
        </div>
      </template>

      <!-- Delete Mode - Shows when products are selected -->
      <template v-else>
        <div class="flex items-center gap-3">
          <Checkbox 
            v-model="selectAllChecked" 
            :indeterminate="isSelectAllIndeterminate"
            @change="toggleSelectAll"
          />
          <span class="text-sm font-medium text-n-slate-12">
            {{ selectedProductIds.length }} produto{{ selectedProductIds.length !== 1 ? 's' : '' }} selecionado{{ selectedProductIds.length !== 1 ? 's' : '' }}
          </span>
        </div>
        <div class="flex gap-3">
          <Button 
            variant="faded" 
            color="blue" 
            size="sm"
            icon="i-lucide-check-square"
            @click="selectAllProducts"
          >
            <span class="min-w-0 truncate">Selecionar todos</span>
          </Button>
          <Button 
            variant="faded" 
            color="slate" 
            size="sm"
            icon="i-lucide-x"
            @click="clearSelection"
          >
            <span class="min-w-0 truncate">Cancelar</span>
          </Button>
          <Button 
            variant="faded" 
            color="blue" 
            size="sm"
            icon="i-lucide-edit-3"
            @click="openBatchDisableModal"
          >
            <span class="min-w-0 truncate">Editar selecionados</span>
          </Button>
          <Button 
            variant="faded" 
            color="ruby" 
            size="sm"
            icon="i-lucide-trash-2"
            @click="openBatchDeleteModal"
          >
            <span class="min-w-0 truncate">Excluir selecionados</span>
          </Button>
        </div>
      </template>
    </div>

    <!-- Products table with state handling -->
    <div class="table-container">
      <!-- Loading state -->
      <div v-if="loading" class="state-container loading-state bg-n-slate-2 dark:bg-n-slate-800 text-n-slate-11">
        <p>Carregando catálogo...</p>
      </div>

      <!-- Error state -->
      <div v-else-if="error" class="state-container error-state bg-n-ruby-9/5 dark:bg-n-ruby-9/10 text-n-slate-11">
        <p>{{ error }}</p>
        <button
          class="inline-flex items-center min-w-0 gap-2 transition-all duration-200 ease-in-out border-0 rounded-lg outline-1 outline bg-n-slate-9/10 text-n-slate-12 hover:enabled:bg-n-slate-9/20 focus-visible:bg-n-slate-9/20 outline-transparent h-8 px-3 text-sm justify-center mt-3"
          @click="() => fetchProducts()">
          <span class="i-lucide-refresh-cw flex-shrink-0"></span>
          <span>Tentar novamente</span>
        </button>
      </div>

      <!-- Empty state -->
      <div v-else-if="products.length === 0" class="state-container empty-state bg-n-slate-2 dark:bg-n-slate-800 text-n-slate-11">
        <p>Nenhum item encontrado.</p>
      </div>

      <!-- Products table (shown when there are products) -->
      <template v-else>
        <div 
          :key="products.length"
          class="w-full bg-white dark:bg-slate-900 rounded-md border border-n-weak overflow-hidden"
        >
          <TableMod 
            :table="table" 
            :truncate-cells="true" 
            :max-cell-length="60" 
            :exclude-from-truncate="['actions', 'checkbox']"
            :get-row-disabled="isProductDisabled"
            class="w-full text-n-slate-12" 
            @row-click="handleRowClick"
          />
          <div class="p-4 border-t border-n-weak">
            <PaginationList
              :table="table"
              :default-page-size="pagination.pageSize"
              :show-page-size-selector="true"
              :total="serverMeta.total_count"
              @page-size-change="async (size) => { 
                pagination.pageIndex = 0;
                pagination.pageSize = size;
                await fetchProducts({ pageIndex: 0, pageSize: size });
              }"
            />
          </div>
        </div>
      </template>
    </div>

    <!-- Modals for products -->
    <CatalogModal v-if="showCatalogModal" :connected-inboxes="connectedInboxes" @close="hideCatalogModal" @success="handleSuccess" />

    <EditProductModal v-if="showEditModal" :product="selectedProduct" :connected-inboxes="connectedInboxes" @close="hideEditModal" @success="handleSuccess" />

    <AlertResponza
      :show="showDeleteModal"
      type="delete"
      :title="deleteModalTitle"
      :message="deleteModalMessage"
      :confirm-text="deleteButtonText"
      :loading="deleteLoading"
      :error="deleteError"
      @confirm="confirmDeleteProduct"
      @cancel="hideDeleteModal"
      @close="hideDeleteModal"
    />

    <!-- Modal de importação de CSV -->
    <ImportSheetModal :show="showSheetModal" @close="hideSheetModal" @success="handleSuccess" @import-cancel="handleImportCancel" />
    
    <!-- General Modal -->
    <GeneralProductModal 
      v-if="showGeneralModal" 
      :title="generalModalTitle"
      :type="generalModalType"
      :action-text="generalModalActionText"
      :data="selectedProductIds"
      :connected-inboxes="connectedInboxes"
      @close="hideGeneralModal" 
      @success="handleSuccess"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted, reactive, h, watch } from 'vue';
import { useToggle } from '@vueuse/core';
import { useStore } from 'vuex';
import { 
  createColumnHelper, 
  getCoreRowModel, 
  getSortedRowModel, 
  useVueTable 
} from '@tanstack/vue-table';
// modals
import CatalogModal from '@/dashboard/components/CatalogModal.vue';
import EditProductModal from './components/EditProductModal.vue';
import ImportSheetModal from './components/ImportSheetModal.vue';
import GeneralProductModal from './components/GeneralProductModal.vue';
import AlertResponza from 'dashboard/components-next/responza/AlertResponza.vue';
// misc
import TableMod from '@/dashboard/components/table/tableMod/TableMod.vue';
import TruncatedCell from '@/dashboard/components/table/tableMod/TruncatedCell.vue';
import BaseCellMod from '@/dashboard/components/table/tableMod/BaseCellMod.vue';
import PaginationList from '@/dashboard/components/table/tableMod/PaginationList.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';
import WootDropdownItem from 'shared/components/ui/dropdown/DropdownItem.vue';
import WootDropdownMenu from 'shared/components/ui/dropdown/DropdownMenu.vue';
import wootAPI from '@/v3/api/apiClient';

export default {
  name: 'ProductManagementView',
  components: {
    CatalogModal,
    EditProductModal,
    ImportSheetModal,
    GeneralProductModal,
    AlertResponza,
    TableMod,
    PaginationList,
    Button,
    Checkbox,
    WootDropdownItem,
    WootDropdownMenu
  },
  setup() {
    const store = useStore();
    const showCatalogModal = ref(false);
    const showEditModal = ref(false);
    const showDeleteModal = ref(false);
    const showSheetModal = ref(false);
    const showGeneralModal = ref(false);
    const generalModalTitle = ref('');
    const generalModalType = ref('');
    const generalModalActionText = ref('');
    const selectedProduct = ref(null);
    const products = ref([]);
    const loading = ref(true);
    const error = ref(null);
    const selectedProductIds = ref([]);
    const selectAllChecked = ref(false);
    const batchMode = ref(false);
    const batchDeleteMessage = ref('');
    const filterType = ref('todos');
    const selectedInboxId = ref('no-filter');
    const searchQuery = ref('');
    const connectedInboxes = ref([]);
    const deleteLoading = ref(false);
    const deleteError = ref(null);

    // Debounce utility function
    const debounce = (func, wait) => {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };

    // Debounced search function
    const debouncedSearch = debounce(async () => {
      pagination.pageIndex = 0; // Reset to first page
      await fetchProducts({ pageIndex: 0, clearCache: true });
    }, 300);

    // Watch for search query changes
    watch(searchQuery, debouncedSearch);
    const [showFilterDropdown, toggleFilterDropdown] = useToggle();
    const closeFilterDropdown = () => toggleFilterDropdown(false);
    const openFilterDropdown = () => toggleFilterDropdown(true);

    const [showPageSizeDropdown, togglePageSizeDropdown] = useToggle();
    const closePageSizeDropdown = () => togglePageSizeDropdown(false);
    const openPageSizeDropdown = () => togglePageSizeDropdown(true);

    const [showInboxFilterDropdown, toggleInboxFilterDropdown] = useToggle();
    const closeInboxFilterDropdown = () => toggleInboxFilterDropdown(false);
    const openInboxFilterDropdown = () => toggleInboxFilterDropdown(true);


    // Table Configuration
    const columnHelper = createColumnHelper();
    const sorting = ref([]);
    
    // Type labels mapping
    const TYPE_LABELS = {
      'digital': 'Digital',
      'physical': 'Físico',
      'phyisical': 'Físico',  // Handle typo in data
      'fisico': 'Físico',
      'produto': 'Físico',
      'servico': 'Digital'
    };

    // Service type labels mapping
    const SERVICE_TYPE_LABELS = {
      'aluguel': 'Aluguel',
      'consulta': 'Consulta',
      'tratamento': 'Tratamento',
      'delivery': 'Delivery',
      'assinatura': 'Assinatura',
      'manutencao': 'Manutenção',
      'instalacao': 'Instalação',
      'reparacao': 'Reparação',
      'limpeza': 'Limpeza'
    };

    // Improved type formatting function
    const formatProductType = (product) => {
      // Get the type from meta_data
      const rawType = product?.meta_data?.type;
      
      if (!rawType) {
        return '---';
      }
      
      // Normalize the type value
      const normalizedType = rawType.toString().trim().toLowerCase();
      
      // Check if this is a service (based on the type itself)
      const serviceTypes = ['delivery', 'consulta', 'tratamento', 'aluguel', 'assinatura'];
      const isService = serviceTypes.includes(normalizedType);
      
      if (isService) {
        // Use service type labels for services
        const displayValue = SERVICE_TYPE_LABELS[normalizedType] || normalizedType.charAt(0).toUpperCase() + normalizedType.slice(1);
        return displayValue;
      } else {
        // Use product type labels for products
        const displayValue = TYPE_LABELS[normalizedType] || 'Outro';
        return displayValue;
      }
    };
    
    // Pagination state - making pageSize reactive to work with PaginationList
    const pagination = reactive({
      pageIndex: 0,
      pageSize: 10,  // Default page size
    });
    
    // Server pagination metadata
    const serverMeta = ref({
      total_count: 0,
      total_pages: 0,
      current_page: 1,
      per_page: 10
    });

    // Price formatting
    const formatPrice = (price) => {
      // Handle null/undefined
      if (price == null) return 'R$ 0,0';
      
      // Convert to number
      const num = Number(price);
      
      // Check if parsing was successful
      if (isNaN(num)) {
        console.warn('Price could not be parsed:', price);
        return 'R$ 0,0';
      }
      
      // Special case for zero values
      if (num === 0) {
        return 'R$ 0,0';
      }
      
      // Format the number with Brazilian currency format
      return `R$ ${num.toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}`;
    };

    // Get inboxes from store
    const inboxes = computed(() => store.getters['inboxes/getInboxes']);
    
    // Get formatted inbox metadata from store
    const formattedInboxMetadata = computed(() => store.getters['inboxMetadata/getFormattedInboxes']);

    // Helper function to map inbox IDs to names
    const getInboxNames = (inboxId) => {
      // If inbox_id is null, it means "todos" was selected
      if (inboxId === null) return 'Todos';
      if (!inboxId) return '---';
      
      // Handle array of inbox IDs
      if (Array.isArray(inboxId)) {
        if (inboxId.length === 0) return '---'; // Disabled products
        const names = inboxId.map(id => {
          // First try to get display_name from store
          const displayName = store.getters['inboxMetadata/getInboxDisplayName'](id);
          if (displayName) return displayName;
          
          // Fallback to inbox object name
          const inbox = inboxes.value.find(inbox => inbox.id === id);
          return inbox ? inbox.name : `ID: ${id}`;
        });
        return names.join(', ');
      }
      
      // Handle single inbox ID
      // First try to get display_name from store
      const displayName = store.getters['inboxMetadata/getInboxDisplayName'](inboxId);
      if (displayName) return displayName;
      
      // Fallback to inbox object name
      const inbox = inboxes.value.find(inbox => inbox.id === inboxId);
      return inbox ? inbox.name : `ID: ${inboxId}`;
    };

    // Helper function to check if product is disabled
    const isProductDisabled = (product) => {
      return Array.isArray(product.inbox_id) && product.inbox_id.length === 0;
    };

    // Computed property for delete modal message
    const deleteModalMessage = computed(() => {
      if (batchMode.value && batchDeleteMessage.value) {
        return batchDeleteMessage.value;
      }
      if (selectedProduct.value) {
        return `Tem certeza que deseja excluir o cadastro "${selectedProduct.value.name}"? Essa ação não pode ser desfeita.`;
      }
      return '';
    });

    // Computed property for delete modal title
    const deleteModalTitle = computed(() => {
      return batchMode.value ? 'Excluir Cadastros' : 'Excluir Cadastro';
    });

    // Computed property for delete button text
    const deleteButtonText = computed(() => {
      return batchMode.value ? 'Excluir cadastros' : 'Excluir cadastro';
    });
    
    // Helper function to get inbox display name for dropdown
    const getInboxDisplayNameForDropdown = (inbox) => {
      // First try to get display_name from store
      const displayName = store.getters['inboxMetadata/getInboxDisplayName'](inbox.id);
      return displayName || inbox.name;
    };

    // Determine if select all is in indeterminate state
    const isSelectAllIndeterminate = computed(() => {
      const currentPageIds = products.value.map(p => p.id);
      const selectedOnPage = currentPageIds.filter(id => selectedProductIds.value.includes(id));
      return selectedOnPage.length > 0 && selectedOnPage.length < currentPageIds.length;
    });


    // Select/deselect functions
    const toggleProductSelection = (productId, event) => {
      // Stop the event from triggering row click
      if (event) {
        event.stopPropagation();
      }
      
      const index = selectedProductIds.value.indexOf(productId);
      if (index === -1) {
        selectedProductIds.value.push(productId);
      } else {
        selectedProductIds.value.splice(index, 1);
      }
      
      // Update selectAllChecked based on selection state
      updateSelectAllState();
    };

    const isProductSelected = (productId) => {
      return selectedProductIds.value.includes(productId);
    };

    const updateSelectAllState = () => {
      if (products.value.length === 0) {
        selectAllChecked.value = false;
        return;
      }
      
      // Count how many products from current page are selected
      const currentPageSelectedCount = products.value.filter(product => 
        selectedProductIds.value.includes(product.id)
      ).length;
      
      selectAllChecked.value = currentPageSelectedCount === products.value.length;
    };

    const toggleSelectAll = () => {
      const currentPageIds = products.value.map(p => p.id);

      if (selectAllChecked.value) {
        // Add only missing current page IDs
        selectedProductIds.value = [
          ...new Set([...selectedProductIds.value, ...currentPageIds])
        ];
      } else {
        // Remove only current page IDs
        selectedProductIds.value = selectedProductIds.value.filter(
          id => !currentPageIds.includes(id)
        );
      }

      updateSelectAllState();
    };

    const clearSelection = () => {
      selectedProductIds.value = [];
      selectAllChecked.value = false;
    };

    const selectAllProducts = async () => {
      try {
        const headers = getAuthHeaders();
        
        // Build parameters object with current filters to get all matching products
        const params = {
          page: 1,
          per_page: 10000 // Large number to get all products
        };

        // Add current filters to get all matching products
        if (searchQuery.value?.trim()) {
          params.search = searchQuery.value.trim();
        }

        if (filterType.value && filterType.value !== 'todos') {
          params.product_type = filterType.value;
        }

        if (selectedInboxId.value && selectedInboxId.value !== 'no-filter') {
          params.inbox_id = selectedInboxId.value;
        }
        
        const response = await wootAPI.get('/api/v1/catalogs', {
          headers,
          params
        });

        const { data: responseData } = response.data;
        
        if (responseData && responseData.length > 0) {
          // Select all product IDs that match current filters
          selectedProductIds.value = responseData.map(product => product.id);
          selectAllChecked.value = true;
        }
      } catch (err) {
        console.error('Failed to select all products:', err);
        // Fallback to current page selection if API fails
        selectedProductIds.value = products.value.map(product => product.id);
        selectAllChecked.value = selectedProductIds.value.length === products.value.length;
      }
    };


    // Batch delete functions
    const openBatchDeleteModal = () => {
      if (selectedProductIds.value.length > 0) {
        batchMode.value = true;
        batchDeleteMessage.value = `Tem certeza que deseja excluir os ${selectedProductIds.value.length} cadastros selecionados? Esta ação não pode ser desfeita.`;
        showDeleteModal.value = true;
      }
    };

    // Batch disable functions
    const openBatchDisableModal = () => {
      if (selectedProductIds.value.length > 0) {
        console.log('Opening batch disable modal with selected IDs:', selectedProductIds.value);
        generalModalTitle.value = 'Editar Cadastros';
        generalModalType.value = 'disable';
        generalModalActionText.value = 'Atualizar';
        showGeneralModal.value = true;
      }
    };

    // Define columns for the table
    const columns = [
      // Checkbox column
      columnHelper.accessor('checkbox', {
        id: 'selection',
        header: ({ table }) => {
          return h(Checkbox, {
            modelValue: selectAllChecked.value,
            indeterminate: isSelectAllIndeterminate.value,
            'onUpdate:modelValue': (value) => {
              selectAllChecked.value = value;
              toggleSelectAll();
            },
            onClick: (e) => e.stopPropagation(),
            disabled: products.value.length === 0
          });
        },
        cell: ({ row }) => {
          return h(Checkbox, {
            modelValue: isProductSelected(row.original.id),
            onChange: (e) => {
              toggleProductSelection(row.original.id, e);
            },
            onClick: (e) => e.stopPropagation(),
          });
        },
        enableSorting: false,
        size: 50,
      }),
      // Name column
      columnHelper.accessor('name', {
        header: () => 'Nome',
        cell: info => h(TruncatedCell, {
          content: info.getValue(),
          maxLength: 40,
          maxLines: 2,
          class: 'text-n-slate-12',
        }),
        enableSorting: true,
        minSize: 150,
      }),
      // Type column (digital or physical)
      columnHelper.accessor(row => row, {  // Pass the entire row instead of just the type
        id: 'type',
        header: () => 'Tipo',
        cell: info => {
          const product = info.getValue(); // This is the full product row
          const displayValue = formatProductType(product);
          
          return h(BaseCellMod, { 
            content: displayValue, 
            noTruncate: true,
            class: 'text-n-slate-12',
          });
        },
        enableSorting: true,
        sortingFn: (rowA, rowB) => {
          // Custom sorting function for type column
          const typeA = formatProductType(rowA.original);
          const typeB = formatProductType(rowB.original);
          return typeA.localeCompare(typeB, 'pt-BR');
        },
        minSize: 100,
      }),
      // Price column
      columnHelper.accessor('price', {
        header: () => 'Valor',
        cell: info => {
          const value = info.getValue();
          return h(BaseCellMod, {
            content: formatPrice(value),
            noTruncate: true,
            class: 'text-n-slate-12 font-medium',
          });
        },
        enableSorting: true,
        minSize: 100,
      }),
      // Category column
      columnHelper.accessor(row => {
        const categories = row.category || [];
        return Array.isArray(categories) 
          ? categories.join(', ') 
          : categories;
      }, {
        id: 'category',
        header: () => 'Categorias',
        cell: info => h(BaseCellMod, {
          content: info.getValue() || '---',
          class: 'text-n-slate-12',
        }),
        enableSorting: true,
        minSize: 150,
      }),
      // Inbox ID column
      columnHelper.accessor('inbox_id', {
        header: () => 'Inboxes',
        cell: info => {
          const value = info.getValue();
          const displayValue = getInboxNames(value);
          return h(BaseCellMod, {
            content: displayValue,
            noTruncate: true,
            class: 'text-n-slate-12',
          });
        },
        enableSorting: true,
        minSize: 100,
      }),
      // Actions column
      columnHelper.accessor(row => row.id, {
        id: 'actions',
        header: () => 'Ações',
        cell: info => {
          const product = info.row.original;
          return h('div', { class: 'flex items-center space-x-2' }, [
            h(Button, {
              variant: 'ghost',
              color: 'slate',
              size: 'sm',
              icon: 'i-lucide-edit-3',
              onClick: event => {
                event.stopPropagation();
                openEditModal(product, products.value.indexOf(product));
              }
            }),
            h(Button, {
              variant: 'ghost',
              color: 'ruby',
              size: 'sm',
              icon: 'i-lucide-trash-2',
              onClick: event => {
                event.stopPropagation();
                openDeleteModal(product, products.value.indexOf(product));
              }
            })
          ]);
        },
        enableSorting: false,
        minSize: 100,
        maxSize: 120,
      }),
    ];

    // Calculate pageCount reactively - ALWAYS use server metadata
    const pageCount = computed(() => {
      return Math.ceil(serverMeta.value.total_count / pagination.pageSize);
    });
    
    // Implementing the table
    const table = computed(() => {
      return useVueTable({
        get data() {
          return products.value;
        },
        columns,
        state: {
          get sorting() {
            return sorting.value;
          },
          get pagination() {
            return pagination;
          }
        },
        onSortingChange: updater => {
          sorting.value = typeof updater === 'function' ? updater(sorting.value) : updater;
        },
        onPaginationChange: async (updater) => {
          const newPag = typeof updater === 'function'
            ? updater({ ...pagination })
            : updater;

          // If neither page nor size changed, do nothing
          if (newPag.pageIndex === pagination.pageIndex && 
              newPag.pageSize === pagination.pageSize) {
            return;
          }

          // Update pagination state BEFORE fetching
          pagination.pageIndex = newPag.pageIndex;
          pagination.pageSize = newPag.pageSize;

          // Fetch the new page (use current pagination.pageSize, not newPag.pageSize)
          await fetchProducts({
            pageIndex: newPag.pageIndex,
            pageSize: pagination.pageSize
          });
          
          // Update select all checkbox state after page change
          updateSelectAllState();
        },
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        
        // Configure pagination
        manualPagination: true,
        get pageCount() {
          return pageCount.value;
        },
        getRowId: row => row.id || row.name,
      });
    });

    // Handle row click - modified to NOT select the row when clicking on checkbox
    const handleRowClick = (row) => {
      openEditModal(row.original, products.value.indexOf(row.original));
    };

    // Funções para controlar os modais
    const openSheetModal = () => {
      console.log('Abrindo modal de importação CSV');
      showSheetModal.value = true;
    };
    
    const hideSheetModal = () => {
      console.log('Fechando modal de importação CSV');
      showSheetModal.value = false;
    };

    const openCatalogModal = () => showCatalogModal.value = true;
    const hideCatalogModal = () => showCatalogModal.value = false;
    
    const openEditModal = (product, idx) => { 
      selectedProduct.value = { ...product, index: idx }; 
      showEditModal.value = true; 
    };
    
    const hideEditModal = () => { 
      showEditModal.value = false; 
      selectedProduct.value = null; 
    };
    
    const openDeleteModal = (product, idx) => { 
      batchMode.value = false;
      batchDeleteMessage.value = '';
      selectedProduct.value = { ...product, index: idx }; 
      showDeleteModal.value = true; 
    };
    
    const hideDeleteModal = () => { 
      showDeleteModal.value = false; 
      selectedProduct.value = null; 
      batchMode.value = false;
      batchDeleteMessage.value = '';
    };

    const hideGeneralModal = () => {
      showGeneralModal.value = false;
    };

    // Helper function to identify if saved item is a product or service
    const identifyItemType = (savedItem) => {
      // Products have discount_price property, services don't
      if (savedItem.hasOwnProperty('discount_price')) {
        return 'product';
      }
      // Services store price in meta_data, products store it directly
      if (savedItem.meta_data?.price !== undefined) {
        return 'service';
      }
      // Fallback: check service-specific types
      const serviceTypes = ['delivery', 'consulta', 'tratamento', 'aluguel', 'assinatura'];
      return serviceTypes.includes(savedItem.meta_data?.type) ? 'service' : 'product';
    };

    // Unified function to handle both product and service saves
    const saveItem = async (savedItemData) => {
      const itemType = identifyItemType(savedItemData);
      
      // Process the saved item data to ensure consistency with loaded data
      const processedItem = {
        ...savedItemData,
        // Ensure inbox_id is properly set (null means "todos")
        inbox_id: savedItemData.inbox_id === undefined ? null : savedItemData.inbox_id,
        // Ensure type is accessible at the top level for filtering
        type: savedItemData.type || savedItemData.meta_data?.type
      };
      
      let newItem;
      if (itemType === 'product') {
        // Add product_type field for consistency with existing code
        newItem = {
          ...processedItem,
          product_type: 'produto',
          // Ensure price is properly formatted for display
          price: processedItem.price || 0
        };
      } else {
        // Add product_type field and extract price from meta_data for services
        newItem = {
          ...processedItem,
          product_type: 'servico',
          price: processedItem.meta_data?.price || processedItem.price || 0
        };
      }
      
      products.value = [newItem, ...products.value];
      
      await refreshWithClearCache();
      
      hideCatalogModal();
    };

    // Handle import cancellation - refresh the products list and close modal
    const handleImportCancel = () => {
      console.log('Import cancelled, refreshing products list');
      fetchProducts();
      hideSheetModal();
    };

    // Consolidated event handlers for standardized modal events
    const handleSuccess = async (data) => {
      console.log('Operation successful, refreshing products list');
      await fetchProducts({ clearCache: true });
      
      // Close any open modals
      hideCatalogModal();
      hideEditModal();
      hideDeleteModal();
      hideGeneralModal();
      hideSheetModal();
      
      // Clear selections for batch operations
      if (selectedProductIds.value.length > 0) {
        clearSelection();
      }
    };

    const confirmDeleteProduct = async () => {
      deleteLoading.value = true;
      deleteError.value = null;

      const headers = getAuthHeaders();
      if (!headers['access-token']) {
        deleteError.value = 'Usuário não autenticado.';
        deleteLoading.value = false;
        return;
      }

      try {
        if (batchMode.value && selectedProductIds.value.length > 0) {
          // Batch delete
          await wootAPI.delete(
            '/api/v1/catalogs/batch_destroy',
            {
              headers,
              data: {
                product_ids: selectedProductIds.value
              }
            }
          );
          clearSelection();
          batchMode.value = false;
          batchDeleteMessage.value = '';
        } else if (selectedProduct.value) {
          // Single item delete
          await wootAPI.delete(`/api/v1/catalogs/${selectedProduct.value.id}`, { headers });
        }

        // Clear cache and refresh data from server
        await fetchProducts({ clearCache: true });
        hideDeleteModal();
      } catch (err) {
        console.error('Erro ao excluir produto(s)', err);
        deleteError.value = err.response?.data?.message || 'Erro interno do servidor. Tente novamente.';
      } finally {
        deleteLoading.value = false;
      }
    };

    const handleDelete = async (data) => {
      console.log('Delete operation completed');

      // Clear cache and refresh data from server to get the current state
      await fetchProducts({ clearCache: true });

      if (Array.isArray(data)) {
        // Batch delete
        clearSelection();
        batchMode.value = false;
        batchDeleteMessage.value = '';
      } else {
        // Single delete - clear selection if the deleted item was selected
        const deletedProductId = data.id;
        if (selectedProductIds.value.includes(deletedProductId)) {
          const selectedIndex = selectedProductIds.value.indexOf(deletedProductId);
          selectedProductIds.value.splice(selectedIndex, 1);
          updateSelectAllState();
        }
      }

      hideDeleteModal();
    };

    // API calls
    const getCookie = (name) => {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    };

    const getAuthHeaders = () => {
      const cookie = getCookie('cw_d_session_info');
      if (!cookie) return {};
      try {
        const sessionInfo = JSON.parse(cookie);
        return { 'access-token': sessionInfo['access-token'], client: sessionInfo.client, uid: sessionInfo.uid };
      } catch { return {}; }
    };

    // Load connected WhatsApp inboxes for product assignment from Vuex store
    const loadConnectedInboxes = () => {
      try {
        // Get formatted inbox metadata from store
        const inboxMetadata = formattedInboxMetadata.value;
        
        // Filter for connected inboxes only
        const connected = (inboxMetadata.results || []).filter(inbox => {
          return inbox.instances && inbox.instances.some(instance => 
            instance.connectionStatus === 2
          );
        });
        
        connectedInboxes.value = connected;
      } catch (err) {
        console.error('Failed to load connected inboxes from store:', err);
        // Don't show error to user
        connectedInboxes.value = [];
      }
    };


    /**
     * Unified function to fetch products with filtering options
     * @param {Object} options
     * @param {number} options.pageIndex - Page index to fetch (defaults to current)
     * @param {number} options.pageSize - Page size to fetch (defaults to current)  
     * @param {boolean} options.clearCache - Whether to clear cache and force fresh data
     */
    const fetchProducts = async ({
      pageIndex = pagination.pageIndex,
      pageSize = pagination.pageSize,
      clearCache = false
    } = {}) => {
      if (clearCache) {
        pagination.pageIndex = 0;
        pageIndex = 0;
      }

      loading.value = true;
      error.value = null;

      try {
        await loadProducts({ pageIndex, pageSize });
      } catch (err) {
        console.error(err);
        error.value = 'Falha ao carregar produtos e serviços.';
      } finally {
        loading.value = false;
      }
    };

    const loadProducts = async ({ pageIndex, pageSize } = {}) => {
      // Use current pagination state if no parameters provided
      pageIndex = pageIndex ?? pagination.pageIndex;
      pageSize = pageSize ?? pagination.pageSize;

      try {
        const page = pageIndex + 1;
        const per_page = pageSize;
        
        // Build parameters object with filters
        const params = {
          page,
          per_page
        };

        // Add search parameter if present
        if (searchQuery.value?.trim()) {
          params.search = searchQuery.value.trim();
        }

        // Add product type filter if not 'todos'
        if (filterType.value && filterType.value !== 'todos') {
          params.product_type = filterType.value;
        }

        // Add inbox filter if not 'no-filter'
        if (selectedInboxId.value !== 'no-filter' && selectedInboxId.value !== undefined) {
          params.inbox_id = selectedInboxId.value === null ? 'null' : selectedInboxId.value;
        }
        
        const headers = getAuthHeaders();
        const [catalogsResponse] = await Promise.all([
          wootAPI.get('/api/v1/catalogs', {
            headers,
            params
          }),
          store.dispatch('inboxes/get')
        ]);

        const { data: responseData, meta } = catalogsResponse.data;
        
        // Process catalog items
        const processedItems = (responseData || []).map(item => {
          const isService = ['delivery', 'consulta', 'tratamento', 'aluguel', 'assinatura'].includes(item.product_type);
          
          return {
            ...item,
            product_type: isService ? 'servico' : 'produto',
            price: item.meta_data?.price ?? item.price ?? 0,
            type: item.product_type
          };
        });

        products.value = processedItems;
        serverMeta.value = meta;
        
        // Update select all checkbox state after loading products
        updateSelectAllState();
        
      } catch (err) {
        console.error(err);
        throw err; // Let fetchProducts handle the error
      }
    };

    // Note: refreshCurrentPage, refreshWithClearCache, and initialLoad have been replaced by fetchProducts

    // Filter selection functions
    const selectFilterType = async (type) => {
      filterType.value = type;
      pagination.pageIndex = 0; // Reset to first page
      closeFilterDropdown();
      await fetchProducts({ pageIndex: 0, clearCache: true });
    };

    // Inbox filter selection function
    const selectInboxFilter = async (inboxId) => {
      selectedInboxId.value = inboxId;
      pagination.pageIndex = 0; // Reset to first page
      closeInboxFilterDropdown();
      await fetchProducts({ pageIndex: 0, clearCache: true });
    };

    // Get filter button label
    const getFilterButtonLabel = () => {
      switch (filterType.value) {
        case 'todos': return 'Todos';
        case 'digital': return 'Digital';
        case 'physical': return 'Físico';
        case 'consulta': return 'Consulta';
        case 'tratamento': return 'Tratamento';
        case 'delivery': return 'Delivery';
        case 'assinatura': return 'Assinatura';
        case 'aluguel': return 'Aluguel';
        case 'ativos': return 'Ativos';
        case 'desativados': return 'Desativados';
        default: return 'Todos';
      }
    };

    // Get inbox filter button label
    const getInboxFilterButtonLabel = () => {
      if (selectedInboxId.value === 'no-filter') {
        return 'Sem filtro';
      }
      if (selectedInboxId.value === null) {
        return 'Todos';
      }
      // First try to get display_name from store
      const displayName = store.getters['inboxMetadata/getInboxDisplayName'](selectedInboxId.value);
      if (displayName) return displayName;
      
      // Fallback to inbox object name
      const inbox = inboxes.value.find(inbox => inbox.id === selectedInboxId.value);
      return inbox ? inbox.name : 'Inbox desconhecido';
    };


    // Page size selection function
    const selectPageSize = async (size) => {
      pagination.pageSize = size;
      pagination.pageIndex = 0;
      closePageSizeDropdown();
      await fetchProducts({ pageIndex: 0, pageSize: size });
    };

    onMounted(async () => {
      // Load products and then connected inboxes from store
      await fetchProducts({ clearCache: true, pageSize: 10 });
      // loadConnectedInboxes now uses the Vuex store, no async needed
      loadConnectedInboxes();
    });

    return {
      showCatalogModal,
      showEditModal,
      showDeleteModal,
      showSheetModal,
      showGeneralModal,
      generalModalTitle,
      generalModalType,
      generalModalActionText,
      products,
      selectedProduct,
      loading,
      error,
      formatPrice,
      getInboxNames,
      isProductDisabled,
      getInboxDisplayNameForDropdown,
      inboxes,
      openCatalogModal,
      openSheetModal,
      hideSheetModal,
      hideCatalogModal,
      openEditModal,
      hideEditModal,
      openDeleteModal,
      hideDeleteModal,
      hideGeneralModal,
      saveItem,
      handleImportCancel,
      handleSuccess,
      handleDelete,
      fetchProducts,
      table,
      pagination,
      handleRowClick,
      sorting,
      pageCount,
      // Batch delete related
      selectedProductIds,
      selectAllChecked,
      isSelectAllIndeterminate,
      toggleProductSelection,
      isProductSelected,
      toggleSelectAll,
      selectAllProducts,
      clearSelection,
      openBatchDeleteModal,
      openBatchDisableModal,
      // New props for batch deletion with modal
      batchMode,
      batchDeleteMessage,
      confirmDeleteProduct,
      deleteLoading,
      deleteError,
      deleteModalMessage,
      deleteModalTitle,
      deleteButtonText,
      // Filter
      filterType,
      showFilterDropdown,
      openFilterDropdown,
      closeFilterDropdown,
      selectFilterType,
      // Page size
      showPageSizeDropdown,
      openPageSizeDropdown,
      closePageSizeDropdown,
      selectPageSize,
      // Search
      searchQuery,
      // Inbox filtering
      selectedInboxId,
      selectInboxFilter,
      getFilterButtonLabel,
      getInboxFilterButtonLabel,
      showInboxFilterDropdown,
      openInboxFilterDropdown,
      closeInboxFilterDropdown,
      // Pagination state
      serverMeta,
      // Connected inboxes for product assignment
      connectedInboxes
    };
  }
};
</script>

<style scoped>
/* Mantem o mesmo estilo da página de profissionais */
:root {
  --primary-color: #2b70e0ff;
  --primary-hover: #3b7eeb;
  --light-primary: #f8f8f8ff;
  --light-primary-hover: #f0f0f3ff;
  --white: #ffffffff;
  --black: #0c0d11ff;
  --bg: rgb(248, 249, 250);
  --light-gray: #f0f0f3ff;
  --text-gray: #5e5e5eff;
  --danger-color: #b31a30ff;
  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --border-radius: 8px;
  --transition-speed: 0.2s;
}

.full-page {
  padding: 2rem 4rem;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.header-custom {
  display: flex;
  gap: 50px;
}

p {
  margin-top: 7px;
}

.table-container {
  margin-top: 1.5rem;
  padding: 0px;
}

.state-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 24px;
  border-radius: var(--border-radius);
  text-align: center;
}

.loading-state {
  position: relative;
  overflow: hidden;
}

/* Dark mode styling for loading state */
:global(.dark) .loading-state {
  background-color: #1e293b; /* dark slate color for dark mode */
  color: #94a3b8; /* light slate color for text in dark mode */
}

/* Add this gradient animation for loading state */
.loading-state::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 200%;
  height: 100%;
  background: linear-gradient(90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0) 100%);
  animation: loading-gradient 1.5s infinite;
}

/* Dark mode gradient */
:global(.dark) .loading-state::before {
  background: linear-gradient(90deg,
      rgba(30, 41, 59, 0) 0%,
      rgba(30, 41, 59, 0.6) 50%,
      rgba(30, 41, 59, 0) 100%);
}

@keyframes loading-gradient {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

.empty-state {
  position: relative;
  overflow: hidden;
}

/* Dark mode styling for empty state */
:global(.dark) .empty-state {
  background-color: #1e293b;
  color: #94a3b8;
}

.error-state {
  background-color: rgba(179, 26, 48, 0.05);
}

/* Dark mode styling for error state */
:global(.dark) .error-state {
  background-color: rgba(179, 26, 48, 0.1);
}

.search-container:hover .search--icon {
  @apply text-n-brand;
}

.filter-actions {
  .dropdown-pane {
    .dropdown-menu__item {
      @apply mb-0;
    }
  }
  
  .button-group {
    &:hover {
      button {
        @apply bg-n-slate-3 dark:bg-n-slate-8;
      }
    }
    
    button {
      @apply transition-colors duration-200;
      
      &:hover {
        @apply bg-n-slate-3 dark:bg-n-slate-8;
      }
    }
  }
}

</style>